export var SemanticTokens = {
    cssVars: {
        // Text Colors
        TextPrimary: '--Text-Primary',
        TextSecondary: '--Text-Secondary',
        TextTertiary: '--Text-Tertiary',
        TextPrimaryInverse: '--Text-Primary-Inverse',
        TextSecondaryInverse: '--Text-Secondary-Inverse',
        TextTertiaryInverse: '--Text-Tertiary-Inverse',
        TextDisabled: '--Text-Disabled',
        TextBrand: '--Text-Brand',
        TextLink: '--Text-Link',
        TextLinkHover: '--Text-Link-Hover',
        TextLinkPressed: '--Text-Link-Pressed',
        TextWarning: '--Text-Warning',
        TextNegative: '--Text-Negative',
        TextPositive: '--Text-Positive',
        TextStatic: '--Text-Static',
        TextStaticInverse: '--Text-Static-Inverse',
        // Background Colors
        BackgroundPrimary: '--Background-Primary',
        BackgroundHover: '--Background-Hover',
        BackgroundPressed: '--Background-Pressed',
        BackgroundL0: '--Background-L0',
        BackgroundL1: '--Background-L1',
        BackgroundL2: '--Background-L2',
        BackgroundL3: '--Background-L3',
        BackgroundSelected: '--Background-Selected',
        BackgroundPrimaryInverse: '--Background-Primary-Inverse',
        BackgroundL0Inverse: '--Background-L0-Inverse',
        BackgroundL1Inverse: '--Background-L1-Inverse',
        BackgroundL2Inverse: '--Background-L2-Inverse',
        BackgroundL3Inverse: '--Background-L3-Inverse',
        BackgroundDisabled: '--Background-Disabled',
        BackgroundBrand: '--Background-Brand',
        BackgroundBrandSubtle: '--Background-Brand-Subtle',
        BackgroundBrandHover: '--Background-Brand-Hover',
        BackgroundBrandPressed: '--Background-Brand-Pressed',
        BackgroundWarning: '--Background-Warning',
        BackgroundWarningSubtle: '--Background-Warning-Subtle',
        BackgroundNegative: '--Background-Negative',
        BackgroundNegativeSubtle: '--Background-Negative-Subtle',
        BackgroundPositive: '--Background-Positive',
        BackgroundPositiveSubtle: '--Background-Positive-Subtle',
        BackgroundStatic: '--Background-Static',
        BackgroundInverseStatic: '--Background-Inverse-Static',
        // Icon Colors
        IconPrimary: '--Icon-Primary',
        IconSecondary: '--Icon-Secondary',
        IconTertiary: '--Icon-Tertiary',
        IconPrimaryInverse: '--Icon-Primary-Inverse',
        IconSecondaryInverse: '--Icon-Secondary-Inverse',
        IconTertiaryInverse: '--Icon-Tertiary-Inverse',
        IconSelected: '--Icon-Selected',
        IconDisabled: '--Icon-Disabled',
        IconBrand: '--Icon-Brand',
        IconHover: '--Icon-Hover',
        IconPressed: '--Icon-Pressed',
        IconInfo: '--Icon-Info',
        IconWarning: '--Icon-Warning',
        IconNegative: '--Icon-Negative',
        IconPositive: '--Icon-Positive',
        IconStatic: '--Icon-Static',
        IconStaticInverse: '--Icon-Static-Inverse',
        // Border Colors
        BorderPrimary: '--Border-Primary',
        BorderSubtle: '--Border-Subtle',
        BorderInverse: '--Border-Inverse',
        BorderSelected: '--Border-Selected',
        BorderDisabled: '--Border-Disabled',
        BorderBrand: '--Border-Brand',
        BorderBrandSubtle: '--Border-Brand-Subtle',
        BorderWarning: '--Border-Warning',
        BorderNegative: '--Border-Negative',
        BorderPositive: '--Border-Positive',
        BorderStatic: '--Border-Static',
        BorderStaticInverse: '--Border-Static-Inverse',
        // Surface Colors
        SurfaceL0: '--Surface-L0',
        SurfaceL1: '--Surface-L1',
        // Overlay Colors
        OverlayPrimary: '--Overlay-Primary',
    },
};
